// extracted by mini-css-extract-plugin
export default {"breadcrumb":"OEZWp","container":"wDMFt","linkContainer":"GPxYB","link":"zVpND","text":"g5T2E","button":"bv1fy","image-container":"SZmsu","imageContainer":"SZmsu"};